import { createSelector } from 'reselect'
import { pathOr, propOr } from 'ramda'

const billingList = state => state.billingList

export const getTransactionsList = createSelector(
  billingList,
  pathOr([], ['entries', 'transactions'])
)

export const hasStripeSubscription = createSelector(
  billingList,
  pathOr(false, ['entries', 'hasStripeSubscription'])
)

export const getBillingListStatus = createSelector(
  billingList,
  propOr('idle', 'listStatus')
)

export const isInvoiceLoading = createSelector(
  billingList,
  propOr([], 'isLoading')
)
